import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { isEmpty } from "lodash/fp";
import InternalRow from "./InternalRow";

const InternalInfo = ({ configResult }) => {
  const { configProducts } = configResult;
  const { configString, orderRowDescription } = useSelector(
    (state) => state.addToCart
  );

  if (!isEmpty(configProducts)) {
    const configProduct = configProducts[0]; // OK, first delivery POC
    const { purchasePrice } = configProduct;

    return (
      <>
        <ul className="lfc-internal-info">
          <InternalRow
            id="lfc-config-string"
            heading="Config string"
            text={configString}
            hasCopyButton
          />
          <InternalRow
            id="lfc-order-row-description"
            heading="Order row description"
            text={orderRowDescription}
            hasCopyButton
          />
          <InternalRow
            id="lfc-purchase-price"
            heading="Purchase price"
            text={purchasePrice.toString()}
            hasCopyButton
            isConcealed
          />
        </ul>

        <p>
          Då funktionen valfri RAL-färg används justeras Config string och Order
          row description då produkten läggs i kassen, alternativt skickas till
          Jeeves.
        </p>
      </>
    );
  }

  return null;
};

InternalInfo.propTypes = {
  configResult: PropTypes.object.isRequired,
};

export default InternalInfo;
